import Capsule, { Environment } from "@usecapsule/react-sdk";

const capsule = new Capsule(
  Environment.BETA,
  process.env.REACT_APP_CAPSULE_API_KEY
);

export default capsule;
